export enum Weights {
  REGULAR = 'regular',
  MEDIUM = 'medium',
  BOLD = 'bold',
  EXTRA_BOLD = 'extra_bold',
  XX_BOLD = 'xx_bold',
  XXX_BOLD = 'xxx_bold',
}
